module.exports = __webpack_public_path__ + "img/banSigh.c7e5aded.svg";